<template>
  <div class="my-org">
    <div class="header-buttons">
      <el-button type="primary" @click="downloadSimplifyTemplateZip" class="but_download" v-show="num1<=0 && !!buttonText">下载简化备案表模板</el-button>
      <el-button type="primary" @click="downloaTemplate" class="but_download" v-show="num1<=0 && !!buttonText">下载备案表模板</el-button>
      <el-button type="primary" @click="getPlan" class="but_one" :disabled='disabledbut' v-show="num1<=0 && !!buttonText">{{buttonText}} </el-button>
    </div>
    <!-- <el-tabs v-model="activeName"> -->
      <!-- <el-tab-pane label="正在备案" name="1"><span slot="label">正在备案<sup class="qp">{{num1}}</sup></span>
        <recording ref="recording" @setNum="setNum"></recording>
      </el-tab-pane>
      <el-tab-pane label="已备案" name="2"><span slot="label">已备案<sup class="qp">{{num2}}</sup></span>
        <recordend ref="recordend" @setNum="setNum"></recordend>
      </el-tab-pane> -->
      <div class="box">
        <div class="title">正在备案<sup class="qp">{{num1}}</sup></div>
        <recording ref="recording" @setNum="setNum"></recording>
      </div>

      <div class="box">
        <div class="title">已备案<sup class="qp">{{num2}}</sup></div>
        <recordend ref="recordend" @setNum="setNum"></recordend>
      </div>



      <!-- <el-tab-pane label="不通过" name="3">
        <recordRefused></recordRefused>
      </el-tab-pane> -->
    <!-- </el-tabs> -->
  </div>
</template>
<script>
import weather from "../../data/emer/weather.js";
import recording from "../../components/burst/BurstRecording.vue";
import recordend from "../../components/burst/BurstRecordend.vue";
// import recordRefused from "../../components/burst/BurstRecordRefused.vue";
import moment from "moment";
export default {
  data() {
    return {
      // 数据个数
      num1: 0,
      num2: 0,
      // 默认选中
      activeName: "1",
      value8: "",
      options: [],
      adddeclare: false,
      addselect: false,
      // 数据
      datalist: [],
      // 申请备案名称
      nameplan: "",
      // 存储步骤
      getStepData: "",
      // 数据类型
      subjectType: "",
      datalistobject: "",
      orgdetail: "",
      disabledbut: false,
      list: "",
      buttonText:'',
      saveButtonFlag: null,
      planType: 'sudden'
    };
  },
  created() {
    if (!sessionStorage.changeBrank) return;
    sessionStorage.changeBrank == 1
      ? (this.activeName = "1")
      : (this.activeName = "1");
  },
  // 销毁
  destroyed() {
    sessionStorage.changeBrank = "";
  },
  methods: {
    setNum (){
      this.num1 = this.$refs.recording.num
      console.log(this.$refs.recordend.tableDataOk)
      this.num2 = this.$refs.recordend.num

      let tableDataOk = this.$refs.recordend.tableDataOk || [];

      if (tableDataOk.some(item => item.state === 8)) {
        this.saveButtonFlag = false;
        this.buttonText = '更新备案';
      } else {
        this.saveButtonFlag = true;
        this.buttonText = '申请新备案';
      }
      sessionStorage.setItem('saveButtonFlag', this.saveButtonFlag);
    },
    // 进入备案
    getPlan() {
      sessionStorage.step = 1;
      if (!sessionStorage.itemName) return this.$message.error("返回类型异常");
      this.list = JSON.parse(sessionStorage.itemName);
      this.disabledbut = true;
      if (this.list.type != null) {
        this.start_process({
          processKey: "SuddenEnvEvent",
          subjectId: this.list.id
        });
      } else {
        this.$message.warning("申报类型不匹配,仅支持企业、政府");
        this.disabledbut = false;
      }
    },
    // 格式化时间+96 f
    formatTime(time) {
      if (!time) {
        return;
      }
      return moment(time).format("YYYY/MM/DD");
    },
    // 获取备案的机构名称
    changeval(val) {
      this.nameplan = val;
    },
    // 获取planId 根据planID生成详细信息
    start_process(params) {
      (async () => {
        let getState = await weather.process_start(params);
        if (getState.status) {
          sessionStorage.planIdval = getState.data.planId;
          if (getState.data.planId) {
            this.get_stepData({
              planId: getState.data.planId
            });
            this.gov_detail({
              planId: getState.data.planId,
              subjectType: this.list.type,
              instanceId: getState.data.instanceId
            });
          }
        } else {
          this.$message.error(getState.msg);
        }
      })();
    },
    //  企业详情接口
    gov_detail(params) {
      (async () => {
        let getState = await weather.subject_detail(params);
        if (getState.status) {
          this.orgdetail = getState.data;
          sessionStorage.datalistobj = JSON.stringify(this.orgdetail);
          sessionStorage.subjectId = this.orgdetail.id;
          if (this.orgdetail) {
            this.save_step({
              planId: sessionStorage.planIdval,
              step: 1
            });
            this.save_subject(this.orgdetail);
            let listID = JSON.parse(sessionStorage.itemName).type;
            sessionStorage.step = this.getStepData;
            switch (listID) {
              case 0:
                this.$router.push({
                  path: "/burststep",
                  query: {
                    instanceId: params.instanceId
                  }
                });
                break;
              case 1:
                this.$router.push({
                  path: "/burstGovStep",
                  query: {
                    instanceId: params.instanceId
                  }
                });
                break;
              case 2:
                this.$router.push({
                  path: "/burstparkstep",
                  query: {
                    instanceId: params.instanceId
                  }
                });
                break;
              case 3:
                this.$router.push({
                  path: "/burstwtstep",
                  query: {
                    instanceId: params.instanceId
                  }
                });
                break;
              case 4:
                this.$router.push({
                  path: "/burstotherstep",
                  query: {
                    instanceId: params.instanceId
                  }
                });
                break;
              default:
                this.$message.error("申报单位类型异常,请重新选择申报单位");
            }
          }
        } else {
          this.$message.error(getState.msg);
        }
      })();
    },
    // 获取存储步骤
    get_stepData(params) {
      // (async () => {
      //   let getState = await weather.get_step(params);
      //   if (getState.status) {
      //     this.getStepData = getState.data;
      //   } else {
      //     this.$message.error(getState.msg);
      //   }
      // })();
      this.getStepData = 1;
    },
    //  存储步骤
    save_step(params) {
      (async () => {
        let getState = await weather.save_step(params);
        if (getState.status) {
        } else {
          this.$message.error(getState.msg);
        }
      })();
    },
    // 存储信息
    save_subject(params) {
      (async () => {
        let getState = await weather.save_subject(params);
        if (getState.status) {
          // console.log('成功')
        } else {
          this.$message.error(getState.msg);
        }
      })();
    },


    downloaTemplate() {
      if (!sessionStorage.itemName) return this.$message.error("返回类型异常");
      const list = JSON.parse(sessionStorage.itemName);
      if (list.type != null) {
        window.location.href = `/api/emer/plan/${this.planType}/template?subjectId=${list.id}`;
      }
      else {
        this.$message.warning("申报类型不匹配,仅支持企业、政府");
      }
    },
    downloadSimplifyTemplateZip() {
      if (!sessionStorage.itemName) return this.$message.error("返回类型异常");
      const list = JSON.parse(sessionStorage.itemName);
      if (list.type != null) {
        window.location.href = `/api/emer/plan/${this.planType}/simplifyTemplateZip?subjectId=${list.id}`;
      }
      else {
        this.$message.warning("申报类型不匹配,仅支持企业、政府");
      }
    }
  },
  components: {
    recording,
    recordend,
    // recordRefused
  }
};
</script>
<style lang="stylus" scoped>
.my-org {
  position: relative;
  z-index: 1;

  .header-buttons {
    position: absolute;
    right: 0;
    z-index: 2;
    .but_one {
      margin-left 10px;
    }
  }
}

.p-color1 {
  color: #000;
  font-size: 16px;
}

.el-select {
  width: 100%;
}
.qp {
  position: relative;
  top: 0px;
  padding: 0 5px;
  text-align: center;
  white-space: nowrap;
  border-radius: 10px;
  font-size: 12px;
  background-color: #f56c6c;
  color: #fff;
}

.box + .box {
  margin-top:30px;
}

.title {
  color: #20a0ff;
  margin-bottom:20px;
  padding-left:10px;
  position:relative;
}

.title:before {
  content:'';
  position:absolute;
  top:4px;
  bottom:0;
  left:0;
  border-left:3px solid #20a0ff;
}
</style>



// WEBPACK FOOTER //
// BurstRecord.vue?35fc701e